import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Up to two initials for an avatar ("Jane Wanjiru Doe" -> "JW"). */
export function initialsOf(name: string) {
  return name.split(/\s+/).filter(Boolean).map((part) => part[0]).join("").slice(0, 2).toUpperCase();
}

/** Compact facility name for tight spaces (the sidebar): registry capitals
    become title case and a trailing legal suffix is dropped.
    "LIANCIS MEDICAL CENTRE LIMITED" -> "Liancis Medical Centre". */
export function shortFacilityName(name: string) {
  const cased = name === name.toUpperCase() ? toTitleCase(name.toLowerCase()) : name;
  return cased.replace(/[\s,]+(limited|ltd\.?|plc|llc|inc\.?)$/i, "").trim() || cased;
}

/** Capitalise the first letter of each word as the user types. The rest of the
    word is left alone so names like "McDonald" survive; applied in onChange so
    the submitted value matches what is shown. */
export function toTitleCase(value: string) {
  return value.replace(/(^|[\s'’-])(\p{Ll})/gu, (_, separator: string, letter: string) => separator + letter.toUpperCase());
}
